import {
  CAT_PRODUCTS,
  CAT_COMPANIES,
  CAT_COMPONENTS,
  CAT_PATENTS,
  CAT_TRADEMARKS,
  CAT_CONTACTS,
  CAT_BRANDS,
  CAT_EVENTS,
  CAT_EVENT_TYPES,
  CAT_EVENT_THEMES,
  CAT_RESEARCHES,
  CAT_PRODUCT_ORDERS,
  CAT_TYPES,
  CAT_STANDING_REPORTS,
  CAT_WEBSITE_DEALS,
  CAT_WEBSITE_SERVICES,
  CAT_WEBSITES,
  CAT_STATUSES,
  CAT_NEWS,
  CAT_COMPANY_NEWS,
  CAT_INFO_REQUESTS,
  CAT_ANALYZE_REQUESTS,
  CAT_AI_NEWS,
  CAT_SOCIAL_MEDIA_SCRAPER_INSTAGRAM,
  CAT_SOCIAL_MEDIA_SCRAPER_FACEBOOK,
  CAT_SOCIAL_MEDIA_SCRAPER_X,
  CAT_SOCIAL_MEDIA_SCRAPER_YOUTUBE,
  CAT_SOCIAL_MEDIA_SCRAPER_LINKEDIN,
  CAT_NEWSLETTER_EMAILS,
  CAT_NEWSLETTER_DOMAINS,
  CAT_AI_NEWS_PROMPTS,
  CAT_VARIATIONS,
  CAT_ATTENDING_REQUESTS,
  CAT_SOCIAL_MEDIA_SCRAPER_ALL,
  CAT_INFORMATION_SOURCES,
  CAT_GLOBAL_SEARCH,
  CAT_ACTIVITY_SPHERES,
} from '@/app/utils/Collections.js';
export default {
  [CAT_PRODUCTS]: 1,
  [CAT_COMPANIES]: 2,
  [CAT_COMPONENTS]: 3,
  [CAT_PATENTS]: 4,
  [CAT_TRADEMARKS]: 5,
  [CAT_CONTACTS]: 6,
  [CAT_BRANDS]: 7,
  [CAT_EVENTS]: 8,
  [CAT_RESEARCHES]: 10,
  [CAT_EVENT_THEMES]: 11,
  [CAT_EVENT_TYPES]: 12,
  [CAT_PRODUCT_ORDERS]: 13,
  [CAT_TYPES]: 14,
  [CAT_STANDING_REPORTS]: 15,
  [CAT_WEBSITE_DEALS]: 16,
  [CAT_WEBSITE_SERVICES]: 17,
  [CAT_WEBSITES]: 18,
  [CAT_STATUSES]: 19,
  [CAT_NEWS]: 20,
  [CAT_COMPANY_NEWS]: 21,
  [CAT_INFO_REQUESTS]: 22,
  [CAT_ANALYZE_REQUESTS]: 23,
  [CAT_AI_NEWS]: 24,
  [CAT_SOCIAL_MEDIA_SCRAPER_INSTAGRAM]: 25,
  [CAT_SOCIAL_MEDIA_SCRAPER_FACEBOOK]: 26,
  [CAT_SOCIAL_MEDIA_SCRAPER_X]: 27,
  [CAT_SOCIAL_MEDIA_SCRAPER_YOUTUBE]: 28,
  [CAT_SOCIAL_MEDIA_SCRAPER_LINKEDIN]: 29,
  [CAT_NEWSLETTER_EMAILS]: 30,
  [CAT_NEWSLETTER_DOMAINS]: 31,
  [CAT_AI_NEWS_PROMPTS]: 32,
  [CAT_VARIATIONS]: 33,
  [CAT_ATTENDING_REQUESTS]: 34,
  [CAT_SOCIAL_MEDIA_SCRAPER_ALL]: 35,
  [CAT_INFORMATION_SOURCES]: 36,
  [CAT_GLOBAL_SEARCH]: 37,
  [CAT_ACTIVITY_SPHERES]: 38,
};
